/**
 * Regenera e obtém um novo token CSRF e o insere num campo hidden do formulário.
 * @param {HTMLFormElement} form      Formulário que será atualizado com o token renovado.
 * @returns {Promise<string>}
 */
async function regenerateCsrfToken(form = null)
{
    try {
        let csrfToken = "";
        let url = window.location.href.toString();
        let httpMethod = "POST";
        let formData = new FormData();
        formData.append("action", "get_renewed_csrf_token");

        let response = await fetch(url, {
            method: httpMethod,
            body: formData,
            credentials: "include",
            cache: "no-cache"
        });

        let responseResult = await response.json();
        if (responseResult.data && responseResult.data.token) {
            csrfToken = responseResult.data.token;
            $("[name=csrf_token]").val(csrfToken);
        }

        return csrfToken;
    } catch (e) {
        console.error(e);
        const msg = formMessage.createFormMessage({
            status: "error",
            message: "O servidor da aplicação retornou um erro inesperado. Por favor, tente novamente!"
        });
        $(form).before(msg);
    }
}
